import * as React from 'react';
import { Input } from 'semantic-ui-react';
import { Props, propTypes } from './props';
import { State } from './state';

export class NumericEditor extends React.Component<Props, State> {
  static propTypes = propTypes;

  input: Input;

  private cancelBeforeStart: boolean;
  
  constructor(props: Props) {
    super(props);
    this.cancelBeforeStart = this.props.charPress != null && 
      ('1234567890'.indexOf(this.props.charPress) < 0);
    
    let value = this.props.value.toString();
    if (!this.cancelBeforeStart && this.props.charPress) {
      value = value + this.props.charPress;
    }

    this.state = {
      value: parseInt(value, 10)
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  render() {
    return (
      <Input
        type="number"
        ref={(input: Input) => { this.input = input; }}
        value={this.state.value}
        onChange={this.handleChange}
        style={{width: '100%', textAlign: 'right'}}
      />
    );
  }

  onKeyDown(event: KeyboardEvent) {
    if (this.isLeftOrRight(event)) {
      event.stopPropagation();
      return;
    }

    if (!this.isKeyPressedNumeric(event)) {
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }

  isCharNumeric(charStr: string) {
    return !!/\d/.test(charStr);
  }

  isKeyPressedNumeric(event: KeyboardEvent) {
    const charCode = this.getCharCodeFromEvent(event);
    const charStr = event.key ? event.key : String.fromCharCode(charCode);
    return charStr === 'Backspace' || this.isCharNumeric(charStr);
  }

  isLeftOrRight(event: KeyboardEvent) {
    return [37, 39].indexOf(event.keyCode) > -1;
  }

  handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    this.setState({value: parseInt(event.currentTarget.value, 10)});
  }

  getCharCodeFromEvent(event: KeyboardEvent) {
    event = event || window.event;
    return (typeof event.which === 'undefined') ? event.keyCode : event.which;
  }

  getValue() {
    return this.state.value;
  }

  isCancelBeforeStart() {
    return this.cancelBeforeStart;
  }

  isCancelAfterEnd() {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/editors/numeric/component.tsx